var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wrapper"},[_c('header-widget',{on:{"openMenu":(value) => (_vm.menuOpen = value)}}),_c('topbar-simple'),_c('section',{staticClass:"content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }